export default "__VITE_PUBLIC_ASSET__c187f28d__"